import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <h1>{{ 'questionPool.Manage question pools' | translate }}</h1>
            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn add" ng-click="vm.addQuestionPool()">{{ 'questionPool.Add question pool' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'questionPool.Name' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('questionCount')"><a ng-click="vm.list.sortBy('questionCount')">{{ 'questionPool.Questions' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('status')"><a ng-click="vm.list.sortBy('status')">{{ 'questionPool.Status' | translate }}</a></th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items" ng-class="{status04: item.status === vm.FORMS_POOL_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.pool.edit({ id: item.id })">{{ item.activeI18n.name }}</a></td>
                        <td>{{ item.questionCount }}</td>
                        <td>{{ vm.FORMS_POOL_ENUM.LABELS[item.status] }}</td>
                        <td class="actions">
                            <a class="btn edit" ui-sref="authorized.forms.settings.pool.edit({ id: item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deletePool(item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    </div>
    `
})
export default class {
    constructor ($translate, ListFactory, ModalService, QuestionPoolResource, QuestionService, DATATABLES, FORMS_POOL_ENUM) {
        this.$translate = $translate;
        this.QuestionPoolResource = QuestionPoolResource;
        this.DATATABLES = DATATABLES;
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;
        this.list = ListFactory.createWithPagination(QuestionPoolResource.query.bind(QuestionPoolResource));
        this.list.fetch({ expand: 'activeI18n' });
    }

    addQuestionPool () {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-pool-add ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()"></forms-settings-pool-add>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => {
            this.list.fetch({ expand: 'activeI18n' });
        });
    }

    deletePool (id) {
        this.ModalService.confirm(
            this.$translate.instant('questionPool.Are you sure you want to delete this question pool')
            , 'large'
        ).then(() => {
            this.QuestionPoolResource.delete({ id }).$promise.then(() => {
                this.list.fetch({ expand: 'activeI18n' });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/pool/list/index.js